import React from 'react';
import PropTypes from 'prop-types';

import { IconButton as MuiIconButton } from '@material-ui/core';

const IconButton = ({ children, onClick, ...rest }) => {
  return (
    <MuiIconButton
      {...rest}
      onClick={onClick}
    >
      { children }
    </MuiIconButton>
  )
}

IconButton.defaultProps = {
  onClick: () => {},
}

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
}

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/base/IconButton/IconButton.js